import {NgxEditorModule} from 'ngx-editor';
import {FormsModule} from '@angular/forms';
import {RtEditorComponent} from './rt-editor.component';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

@NgModule({
    declarations: [RtEditorComponent],
    imports: [CommonModule, FormsModule, NgxEditorModule],
    exports: [RtEditorComponent]
})
export class SharedModule {
}
